import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iddat-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
})
export class IddatLoaderComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }
}
